module.exports = __webpack_public_path__ + "static/media/ovulation.e923bc91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/healthTools/ovulation.png
// module id = 1417
// module chunks = 2